var render = function render(_c,_vm){return _c('span',[_vm._v(" "+_vm._s(_vm.props.value !== undefined && typeof _vm.props.value.toLocaleString === "function" ? _vm.props.value.toLocaleString() : _vm.props.value || "")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }